var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "spa-soft-header-detail" }, [
    _c("div", { staticClass: "spa-soft-header-detail-wrapper" }, [
      _c("div", { staticClass: "spa-soft-header-detail-left" }, [
        _c("div", { staticClass: "spa-name" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.propertyData.facilityName) + "\n      "
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.showDateAndGuestCta
        ? _c("div", { staticClass: "spa-soft-header-detail-right" }, [
            _c("div", { staticClass: "spa-soft-header-detail-info" }, [
              _c("div", { staticClass: "date-wrapper" }, [
                _c(
                  "button",
                  {
                    staticClass: "selected-date",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.handleClick($event)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.selectedDateFormatted) +
                        "\n          "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "marker" }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "selected-guests",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.handleClick($event)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.numberOfAdultsLabel) +
                      "\n        "
                  ),
                ]
              ),
            ]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }